/**
 * EmployeeFileCategoryService
 * Service for EmployeeFileCategory entity operations
 * Route: api/employeefilecategories
 */
import { CrudService } from '../base/CrudService';
/**
 * EmployeeFileCategoryService
 * Handles employee file category CRUD operations
 */
export class EmployeeFileCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EmployeeFileCategoryService.DEFAULT_SERVICE_PATH,
            basePath: EmployeeFileCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EmployeeFileCategoryService.DEFAULT_SERVICE_PATH = 'hr';
EmployeeFileCategoryService.BASE_PATH = 'api/employeefilecategories';
//# sourceMappingURL=EmployeeFileCategoryService.js.map